// extracted by mini-css-extract-plugin
export default {"Education":"Education_Education__wDhfz","timeline":"Education_timeline__cBy99"};